<template>
  <div class="dialog-unit-edit">
    <Form :model="unitMsg" :label-width="100" ref="editUnitForm">
      <FormItem label="单位属性：" prop="type" :rules="{required: true, message: '单位属性不能为空', trigger: 'change'}">
        <Select v-model="unitMsg.type" @on-change='handleCode'>
          <Option :value="item.value" v-for="item in typeList" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem label="单位名称：" prop="name" :rules="{required: true, message: '单位名称不能为空', trigger: 'blur'}">
        <Input v-model="unitMsg.name" :autofocus="true" placeholder="请输入单位名称"></Input>
      </FormItem>
      <FormItem label="单位代码：" prop="code" :rules="{required: true, message: '单位代码不能为空', trigger: 'blur'}">
        <Input  :maxlength="unitMsg.type=='1'?5:18" v-model="unitMsg.code" :placeholder="unitMsg.type=='1'?'请填写学校代码':'请填写社会信用代码'"></Input>
      </FormItem>
      <FormItem label="单位类型：" prop="schoolType">
        <Input :maxlength="60" v-model="unitMsg.schoolType" :autofocus="true" placeholder="请输入单位类型"></Input>
      </FormItem>
      <FormItem label="所在省份：" prop="provinceCode" :rules="{required: true, message: '所在省份不能为空', trigger: 'change'}">
        <Select v-model="unitMsg.provinceCode">
          <Option :value="item.dm" v-for="item in provinceList" :key="item.id">{{item.mc}}</Option>
        </Select>
      </FormItem>
      <FormItem label="开始时间：" prop="startTime">
        <element-date v-model="unitMsg.startTime" :query="{type: 'datetime', placeholder: '请选择开始时间'}"></element-date>
      </FormItem>
      <FormItem label="结束时间：" prop="endTime">
        <element-date v-model="unitMsg.endTime" :query="{type: 'datetime', placeholder: '请选择结束时间'}"></element-date>
      </FormItem>
      <FormItem label="状态：" prop="enableDisable" :rules="{required: true, message: '状态不能为空', trigger: 'blur'}">
        <Select v-model="unitMsg.enableDisable">
          <Option value="1">启用</Option>
          <Option value="0">停用</Option>
        </Select>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
import ElementDate from '../../../components/elements/date'
export default {
  components: {ElementDate},
  props: {
    query: '' // id, name, code
  },
  data () {
    return {
      unitMsg: { // form表单的属性值
        name: '',
        code: '',
        startTime: '',
        endTime: '',
        status: '1'
      },
      typeList: [
        {
          value: '1',
          label: '学校'
        }, {
          value: '2',
          label: '其他'
        }
      ],
      provinceList: [],
      defaultUnit: {},
      formLoading: true
    }
  },
  created () {
    this.fetchProList()
    if (this.query) {
      this.fetchUnitMsg();
      // let param = this.query.split(',');
      // this.unitMsg = {
      //   id: param[0],
      //   name: param[1],
      //   code: param[2]
      // }
      // this.defaultUnit = {
      //   id: param[0],
      //   name: param[1],
      //   code: param[2]
      // };
    } else {
      this.formLoading = false;
    }
  },
  methods: {
    /**
     * 获取role的详细信息
     */
    fetchProList () {
      let url = '/conf/confProvince/list'
      this.post(url).then(res => {
        this.provinceList = res.data
      })
    },

    fetchUnitMsg () {
      const _self = this;
      _self.fetch('/school/school/info/' + _self.query).then(res => {
        _self.unitMsg = res.data;
        _self.unitMsg.enableDisable = _self.unitMsg.enableDisable + '';
        _self.defaultUnit = JSON.parse(JSON.stringify(res.data));
        _self.formLoading = false;
      });
    },
    handleCode () {
      this.unitMsg.code = ''
    },
    /**
     * 框架弹窗确认时被调用，必须方法
     * @returns {Promise<any>}
     */
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editUnitForm'].validate((valid) => {
          if (valid) {
            if (_self.unitMsg.provinceCode) {
              let currentValue = _self.provinceList.filter(item => item.dm === _self.unitMsg.provinceCode)
              _self.unitMsg.provinceName = currentValue[0].mc
            }
            let param = _self.compare(_self.defaultUnit, _self.unitMsg);
            if (Object.keys(param).length === 0) {
              resolve();
              return;
            }
            if (_self.defaultUnit.id) {
              param.id = _self.defaultUnit.id;
            }
            _self.post('/school/school/saveSchool', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/unitEdit.vue